<template>
  <div class="ct-shell ctd-demo">
    <b-modal
      ref="login-cta"
      centered
      hide-footer
      hide-header
      content-class="login-cta-modal"
    >
      <div class="text-center p-3">
        <h4 class="font-weight-bold mb-3">
          Crea tu cuenta y corrige tus propios test
        </h4>
        <p class="text-muted">
          Este es un protocolo de ejemplo ya aplicado. Con tu cuenta ingresas
          las emisiones de tu propio evaluado, corriges el test y descargas el
          informe en Word.
        </p>
        <!-- El premio se nombra una vez por pantalla: acá lo dice la línea de
             bonos (que además suma el referido cuando tiene montos) y el botón
             se queda con el verbo. Donde no hay línea —la opción del chat, la
             tira de descarga— el número viaja en el propio botón. -->
        <p v-if="bonusHtml" class="mb-3" v-html="bonusHtml"></p>
        <b-button pill variant="primary" size="lg" @click="login">
          Crear mi cuenta
        </b-button>
      </div>
    </b-modal>

    <!-- La oferta, antes de la demo. Quien llega desde un anuncio viene por
         los usos gratis, y hasta acá el único botón para reclamarlos era el
         del cierre del chat: aparecía a los ~16 segundos y al fondo del
         scroll, así que en un teléfono no se veía nunca. Es el mismo botón y
         el mismo nombre (`accountCta`), puesto donde se lee primero.

         La nota hace dos cosas: dice que no se pide tarjeta, y aclara que la
         demo se ve igual sin cuenta, para que la barra no se lea como un muro
         en la puerta. -->
    <div class="ctd-offer">
      <button type="button" class="ctd-offer-btn" @click="login">
        {{ accountCta }}
      </button>
      <p class="ctd-offer-note">
        Con tu cuenta de Google, sin tarjeta. La demo de abajo se ve sin
        registrarse.
      </p>
    </div>

    <!-- Burbuja de chat: mismo patrón que el resto de los productos (mensaje
         que se escribe solo y, al terminar, las acciones disponibles). -->
    <section class="ct-product-chat is-demo-open" aria-label="Demo de corrección de test">
      <div class="ct-chat-inner">
        <div class="ct-chat-intro">
          <div class="ct-chat-row">
            <div ref="chatBubble" class="ct-chat-bubble">
              <p>
                {{ streamedTitle
                }}<span
                  v-if="streamPhase === 'title'"
                  class="ct-stream-cursor"
                  aria-hidden="true"
                />
              </p>
              <span v-if="streamedText || streamPhase === 'text'">
                {{ streamedText
                }}<span
                  v-if="streamPhase === 'text'"
                  class="ct-stream-cursor"
                  aria-hidden="true"
                />
              </span>
            </div>
          </div>

          <div v-if="showClosing" class="ct-chat-options">
            <button
              type="button"
              class="ct-chat-option ct-chat-option--main"
              @click="login"
            >
              {{ accountCta }}
            </button>
            <!-- El único enlace del SPA a la capa indexable de Django, y a
                 propósito uno solo. Para Google no cuenta: vive dentro de Vue,
                 así que tendría que renderizar el SPA para encontrarlo. El
                 descubrimiento lo hacen el sitemap y la solicitud manual de
                 indexación. Esto es para la persona que acaba de ver la
                 corrección y quiere leer un informe entero.

                 Acá hubo también un bloque grande con auto-scroll al terminar
                 la corrección. Se sacó: las páginas nuevas tienen que quedar lo
                 más discretas posible para quien ya está en el sitio, y ese
                 bloque no aportaba descubrimiento por lo mismo de arriba. -->
            <a
              v-if="MUESTRAS_PUBLICADAS"
              class="ct-chat-option"
              href="/informes-de-muestra/"
            >
              📄 Ver informes de muestra completos
            </a>
            <button type="button" class="ct-chat-option" @click="replay">
              ↻ Ver la demo de nuevo
            </button>
            <button type="button" class="ct-chat-option" @click="backToMenu">
              ↩ Volver al menú
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="ct-demo-expander is-open" aria-label="Corrección de test de ejemplo">
      <div ref="demoInner" class="ct-direct-inner">
        <header class="ct-direct-head">
          <div>
            <div class="ct-direct-kicker">
              {{ kicker }} <span class="ctd-badge">Demo</span>
            </div>
            <h2>
              Corrección automática de Test y obtención del informe en Word
            </h2>
          </div>
        </header>

        <div class="ct-direct-body">
          <!-- Arranque: los dieciséis antes de entrar a uno.
               Una psicóloga que llega buscando WISC-V y ve solo TEPROSIF-R se
               va creyendo que el producto no es para ella. Mostrar el catálogo
               un segundo y después elegir uno cuesta lo mismo que abrir
               directo en uno, y dice las dos cosas: son dieciséis, y así de rápido
               es cualquiera. -->
          <transition name="ctd-fade">
            <div v-if="stage === 'choosing'" class="ctd-chooser">
              <p class="ctd-chooser-title">Elige el test que aplicaste</p>
              <div class="ctd-chooser-cols">
                <div
                  v-for="profession in professions"
                  :key="profession.id"
                  class="ctd-chooser-col"
                >
                  <p class="ctd-chooser-prof">{{ profession.label }}</p>
                  <ul class="ctd-chooser-list">
                    <li
                      v-for="test in profession.tests"
                      :key="test.slug"
                      class="ctd-chooser-item"
                      :class="{ 'is-picked': pickedSlug === test.slug }"
                    >
                      <span class="ctd-chooser-icon" aria-hidden="true">{{ test.icon }}</span>
                      <span class="ctd-chooser-name">{{ test.label }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </transition>

          <!-- Réplica no interactiva de la toolbar del producto: el visitante
               ve qué se eligió (protocolo y edad) sin poder cambiarlo. Todo
               click cae en el CTA de cuenta. -->
          <div
            v-if="stage !== 'choosing'"
            class="ct-toolbar"
            @click="openLoginCta"
          >
            <div class="ct-toolbar-selects">
              <div class="ct-select-chip">
                <label>Profesión</label>
                <select class="ct-toolbar-select" disabled>
                  <option>Fonoaudiología</option>
                </select>
              </div>
              <div class="ct-select-chip">
                <label>Test</label>
                <select class="ct-toolbar-select" disabled>
                  <option>TEPROSIF-R</option>
                </select>
              </div>
              <div class="ct-select-chip ct-age-chip">
                <label>Edad</label>
                <select class="ct-toolbar-select" disabled>
                  <option>{{ ageLabel }}</option>
                </select>
              </div>
            </div>

            <div class="ct-action-row">
              <button
                type="button"
                class="ct-direct-btn"
                :class="{ 'ct-guide-download': stage === 'ready' }"
                :disabled="stage !== 'ready'"
              >
                {{ correctButtonLabel }}
              </button>
            </div>
          </div>

          <div
            v-if="stage !== 'choosing'"
            class="ct-form-rows teprosif-grid"
            :class="{ 'teprosif-grid-compact': stage !== 'ready' }"
          >
            <div
              v-for="(item, index) in items"
              :key="item.key"
              class="ct-item-row"
              :class="{
                'has-value': true,
                'tp-result': stage !== 'ready',
                'ctd-pending': stage !== 'ready' && index >= revealed,
                'ctd-just-revealed': stage === 'correcting' && index === revealed - 1,
              }"
            >
              <template v-if="stage === 'ready'">
                <div class="teprosif-card-main">
                  <div class="ct-num">{{ item.id }}</div>
                  <div class="ct-word" :title="item.label">{{ item.label }}</div>
                  <input
                    class="ct-emission"
                    :value="item.emission"
                    readonly
                    @focus="openLoginCta"
                    @mousedown.prevent="openLoginCta"
                  />
                  <button type="button" class="ct-omit" @click="openLoginCta">
                    Omitida
                  </button>
                </div>
              </template>

              <template v-else>
                <div class="teprosif-card-main teprosif-compact-row">
                  <div class="ct-num">{{ item.id }}</div>
                  <div class="ct-word teprosif-word-inline" :title="item.label">
                    {{ item.label }}
                    <small>{{ item.emission }}</small>
                  </div>
                  <div class="ct-process-inline">
                    <template v-if="index < revealed">
                      <span
                        v-for="(code, codeIdx) in item.codes"
                        :key="codeIdx"
                        class="ct-proc-tag"
                        :class="'ct-proc-' + codeGroup(code)"
                        >{{ code }}</span
                      >
                      <span v-if="!item.codes.length" class="ct-proc-empty">—</span>
                    </template>
                    <span v-else class="ctd-scanning" aria-hidden="true" />
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- Contador en vivo: es lo que el profesional cuenta a mano hoy.
               Solo desde que empieza la corrección: durante la elección del
               test mostraría cuatro ceros de un protocolo que todavía no se
               abre. -->
          <div v-if="hasStarted" class="ctd-counters" aria-live="polite">
            <div
              v-for="row in DEMO_SUMMARY.rows"
              :key="row.key"
              class="ctd-counter"
              :class="'ctd-counter--' + row.key"
            >
              <span class="ctd-counter-num">{{ liveCounts[row.key] }}</span>
              <span class="ctd-counter-label">{{ row.label }}</span>
            </div>
            <div class="ctd-counter ctd-counter--total">
              <span class="ctd-counter-num">{{ liveTotal }}</span>
              <span class="ctd-counter-label">Procesos totales</span>
            </div>
          </div>

          <transition name="ctd-fade">
            <div v-if="showSummary" class="ctd-summary">
              <h3 class="ctd-summary-title">
                Resultado del protocolo · {{ ageLabel }}
              </h3>
              <div class="ctd-table-wrap">
                <table class="ctd-table">
                  <thead>
                    <tr>
                      <th>Tipo de proceso</th>
                      <th>Puntaje</th>
                      <th>Categoría</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in DEMO_SUMMARY.rows" :key="row.key">
                      <td>{{ row.label }}</td>
                      <td class="ctd-num-cell">{{ row.total }}</td>
                      <td>
                        <span class="ctd-cat" :class="'ctd-cat--' + row.level">
                          {{ row.category }}
                        </span>
                      </td>
                    </tr>
                    <tr class="ctd-table-total">
                      <td>Total PSF</td>
                      <td class="ctd-num-cell">{{ DEMO_SUMMARY.total }}</td>
                      <td>
                        <span
                          class="ctd-cat"
                          :class="'ctd-cat--' + DEMO_SUMMARY.totalLevel"
                        >
                          {{ DEMO_SUMMARY.totalCategory }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>15 procesos más frecuentes</td>
                      <td class="ctd-num-cell">—</td>
                      <td>
                        <span class="ctd-cat ctd-cat--risk">
                          {{ DEMO_SUMMARY.fifteen }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p class="ctd-functions-title">Procesos identificados</p>
              <ul class="ctd-functions">
                <li v-for="fn in DEMO_FUNCTIONS" :key="fn">{{ fn }}</li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// La corrección pregrabada que se reproduce sola, montada como paso
// `custom-component` del chatbot TestCorrectionDemo. Nada acá toca RedPsi, ni
// crea Test/School, ni renderiza un .docx, así que un bot que entre a la URL
// no consume nada.
//
// El markup replica el del producto (mismas clases de styles/corregir-test.scss
// que usan TeprosifForm, TestToolbar y ReportBottom), de modo que lo que se ve
// acá es literalmente lo que el visitante encontrará al registrarse.
//
// Todo lo que salga del reproductor (abrir el login, volver al menú) viaja por
// `go-to-step`, que es el único evento que ChatMessageComponent reenvía desde
// un paso custom al chatbot.
import { TEPROSIF_ITEMS } from "@/components/corregir-test/data/teprosifItems";
import {
  DEMO_AGE_LABEL,
  DEMO_ITEMS,
  DEMO_SUMMARY,
  DEMO_FUNCTIONS,
  codeGroup,
  summaryCheck,
} from "@/components/corregir-test/data/teprosifDemoFixture";
import {
  TEST_PROFESSIONS,
  getTestsForProfession,
  isProfessionAvailable,
} from "@/components/corregir-test/constants/testCatalog";
import { streamTypewriter } from "@/components/corregir-test/utils/chatStream";
import { scrollToElementDelayed } from "@/components/corregir-test/utils/guidedScroll";
import { fetchRewards, bonusLine, freeUsesLabel } from "./signupRewards";
import {
  medirDemoIniciada,
  medirDemoTerminada,
} from "@/services/analytics";
import "@/components/corregir-test/styles/corregir-test.scss";

//: ¿Se enlazan las páginas de informes de muestra?
//:
//: Atado a mano a `EN_SITEMAP` de backend/marketing/pages.py, que es el
//: interruptor único de publicación del sitio nuevo. Mientras aquél sea False
//: esas páginas están fuera del sitemap y con noindex, y además todavía no
//: tienen el estilo del resto del sitio: enlazarlas desde acá es mandar a la
//: gente a una página en pausa.
//:
//: El día que se publique el sitio, los dos se prenden juntos. No hace falta
//: acordarse: backend/tests/test_marketing_routing.py compara esta constante
//: con `EN_SITEMAP` y falla si una se mueve sin la otra. El SPA no puede leer
//: el valor de Django en tiempo real sin meter contexto en la shell —y la
//: shell tiene que seguir byte a byte igual a la de antes de esta rama—, así
//: que la copia declarada + el test es el amarre más limpio disponible.
const MUESTRAS_PUBLICADAS = true;

const CHOOSING_TITLE = "Dieciséis test corregidos, no uno.";
const CHOOSING_TEXT =
  "Fonoaudiología, psicología y terapia ocupacional. Elige el que aplicaste y el corrector hace el resto; acá va uno de ejemplo.";
const INTRO_TITLE = "Así se corrige un TEPROSIF-R sin contar a mano.";
const INTRO_TEXT =
  "Este protocolo ya viene aplicado: 37 palabras con la emisión de un niño de 3 años. Mira lo que pasa al corregirlo.";
const CORRECTING_TITLE = "Analizando las 37 emisiones…";
const CORRECTING_TEXT =
  "El corrector compara cada emisión con la palabra objetivo y marca los procesos de simplificación fonológica que encuentra.";
const RESULT_TITLE = "63 procesos detectados en menos de un segundo.";
const RESULT_TEXT =
  "Con los puntajes por tipo de proceso, su categoría según el baremo de la edad, y el informe en Word listo para editar.";
const CLOSING_TITLE = "Así de rápido con cualquiera de los dieciséis.";
const CLOSING_TEXT =
  "Tenemos el WISC-V, el WAIS-IV, el ICAP, el CARAS-R, el Conners, el IDTEL, el TECAL, el STSG, el Perfil Sensorial y el SPM-2, todos con corrección automática.";

//: El test que la demo elige sola. Es el de la ficha pregrabada
//: (teprosifDemoFixture): cambiarlo acá sin cambiar el fixture dejaría el
//: catálogo marcando uno y la rejilla mostrando otro.
const DEMO_SLUG = "teprosif";

// Cuánto se ve el catálogo antes de que uno se marque, y cuánto queda marcado
// antes de entrar al protocolo. Es el "un segundo" del arranque: lo justo para
// leer los dieciséis nombres sin que se sienta una espera.
const CATALOG_HOLD_MS = 2000;
const PICKED_HOLD_MS = 1100;

// Ritmo pensado para que se pueda grabar y seguir con el ojo: cada palabra se
// resuelve en ~110 ms, así que el barrido de las 37 dura poco más de 4 s.
const REVEAL_STEP_MS = 110;

// Cuánto queda el resultado en pantalla antes de que el chat cierre. Sin la
// tira de descarga —que prometía un Word y abría el registro— el resumen es
// el último bloque que aparece, así que el cierre se adelanta: si no, quedan
// tres segundos de pantalla quieta esperando algo que ya no llega.
const CLOSING_DELAY_MS = 4000;

export default {
  name: "TestCorrectionDemoPlayer",
  // Las props que ChatMessageComponent bindea en todo paso custom. No se usan
  // acá, pero declararlas evita que caigan como atributos sueltos en el DOM.
  props: {
    context: { type: Object, required: false, default: () => ({}) },
    condition: { type: String, required: false, default: "" },
    canWork: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      MUESTRAS_PUBLICADAS,
      // Usos gratis de una cuenta nueva, con el número real de la config.
      // null hasta que responde `signup_rewards`: mientras tanto los textos
      // usan su redacción original, sin número.
      rewards: null,
      DEMO_SUMMARY,
      DEMO_FUNCTIONS,
      ageLabel: DEMO_AGE_LABEL,
      // 'choosing' = el catálogo de los dieciséis, antes de entrar a uno.
      // 'ready' = protocolo con las emisiones cargadas (paso 0 del producto).
      // 'correcting' = barrido revelando procesos. 'done' = resultado completo.
      stage: "choosing",
      // Qué test quedó marcado en el catálogo. null mientras se ven los dieciséis.
      pickedSlug: null,
      revealed: 0,
      streamedTitle: "",
      streamedText: "",
      streamPhase: "idle",
      showSummary: false,
      showClosing: false,
      // La demostracion se cuenta una vez por montaje: `replay()`
      // vuelve a correrla entera y no es una visita nueva.
      inicioContado: false,
      finContado: false,
      timers: [],
      items: TEPROSIF_ITEMS.map((item) => ({
        id: item.id,
        key: item.key,
        label: item.label,
        emission: (DEMO_ITEMS[item.key] || {}).emission || "",
        codes: ((DEMO_ITEMS[item.key] || {}).codes || []).slice(),
      })),
    };
  },
  computed: {
    // "3 usos", o "" mientras no haya respuesta.
    freeUses() {
      return freeUsesLabel(this.rewards);
    },
    bonusHtml() {
      return bonusLine(this.rewards);
    },
    // Un solo nombre para la acción, en el chat y en el modal. Nombra lo que
    // la persona gana; sin números todavía, vuelve al texto de siempre.
    accountCta() {
      return this.freeUses
        ? `Crear mi cuenta y recibir ${this.freeUses} gratis`
        : "Crear mi cuenta y corregir mis test";
    },
    correctButtonLabel() {
      if (this.stage === "correcting") return "Corrigiendo…";
      if (this.stage === "done") return "Test corregido";
      return "Corregir emisiones";
    },
    // Se recalcula con `revealed`, así que los números suben a la par de los
    // chips en vez de aparecer ya sumados al final.
    liveCounts() {
      const counts = { est: 0, asim: 0, sust: 0 };
      this.items.slice(0, this.revealed).forEach((item) => {
        item.codes.forEach((code) => {
          counts[codeGroup(code)] += 1;
        });
      });
      return counts;
    },
    liveTotal() {
      return (
        this.liveCounts.est + this.liveCounts.asim + this.liveCounts.sust
      );
    },
    // Los dieciséis, agrupados como los agrupa el producto. Salen de
    // testCatalog.js —el mismo del que se alimenta el selector real— para que
    // no haya una segunda lista que se desincronice.
    //
    // Se excluyen las profesiones platformOnly (los dos Evalúa): solo existen
    // dentro del colegio, y ofrecerlas acá prometería un test que después no
    // aparece en el selector.
    professions() {
      return TEST_PROFESSIONS.filter((profession) =>
        isProfessionAvailable(profession.id)
      )
        .map((profession) => ({
          id: profession.id,
          label: profession.label,
          tests: getTestsForProfession(profession.id).map((test) => ({
            slug: test.slug,
            label: test.label,
            icon: test.icon,
          })),
        }))
        .filter((profession) => profession.tests.length);
    },
    // Si la corrección ya arrancó. No es `stage !== "ready"`: eso también es
    // cierto mientras se elige el test, que es antes de que exista protocolo.
    hasStarted() {
      return this.stage === "correcting" || this.stage === "done";
    },
    // El kicker de la cabecera: mientras se elige no hay profesión todavía.
    kicker() {
      if (this.stage === "choosing") return "Dieciséis test";
      return "Fonoaudiología";
    },
  },
  created() {
    fetchRewards("Corregir Test").then((rewards) => {
      this.rewards = rewards;
    });
    // Red de seguridad en desarrollo: si alguien edita las marcas del fixture y
    // no los puntajes (o al revés), la demo mostraría un total que no cuadra.
    if (process.env.NODE_ENV !== "production") {
      const check = summaryCheck();
      if (check.mismatches.length) {
        console.warn(
          "[TestCorrectionDemo] El fixture TEPROSIF no cuadra:",
          check
        );
      }
    }
  },
  mounted() {
    // Sin esto ChatMessageComponent deja el botón "continuar" esperando a un
    // componente que nunca avisa que terminó de cargar.
    this.$emit("componente-listo");
    // Aca y no en `play()`: `replay()` pasa por ahi.
    this.contarInicio();
    this.play();
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    codeGroup,
    addTimer(fn, delay) {
      this.timers.push(window.setTimeout(fn, delay));
    },
    clearTimers() {
      this.timers.forEach((timer) => window.clearTimeout(timer));
      this.timers = [];
    },
    say(title, text) {
      this.streamPhase = "title";
      this.streamedTitle = "";
      this.streamedText = "";
      return streamTypewriter(title, (char) => {
        this.streamedTitle += char;
      })
        .then(() => {
          this.streamPhase = "text";
          return streamTypewriter(text, (char) => {
            this.streamedText += char;
          });
        })
        .then(() => {
          this.streamPhase = "done";
        });
    },
    play() {
      this.say(CHOOSING_TITLE, CHOOSING_TEXT);
      // El catálogo se ve, uno se marca solo, y recién entonces se entra al
      // protocolo. El orden importa: si se entrara directo al TEPROSIF-R, la
      // visitante que busca otro test no llega a enterarse de que existe.
      this.addTimer(() => {
        this.pickedSlug = DEMO_SLUG;
      }, CATALOG_HOLD_MS);
      this.addTimer(() => this.enterProtocol(), CATALOG_HOLD_MS + PICKED_HOLD_MS);
    },
    enterProtocol() {
      this.stage = "ready";
      this.say(INTRO_TITLE, INTRO_TEXT);
      // Un respiro para leer el protocolo cargado antes de que se corrija solo.
      this.addTimer(() => this.startCorrection(), 3200);
    },
    startCorrection() {
      this.stage = "correcting";
      this.say(CORRECTING_TITLE, CORRECTING_TEXT);
      this.items.forEach((item, index) => {
        this.addTimer(() => {
          this.revealed = index + 1;
        }, 500 + index * REVEAL_STEP_MS);
      });
      const sweepMs = 500 + this.items.length * REVEAL_STEP_MS;
      this.addTimer(() => this.finishCorrection(), sweepMs + 400);
    },
    finishCorrection() {
      this.contarFin();
      this.stage = "done";
      this.revealed = this.items.length;
      this.say(RESULT_TITLE, RESULT_TEXT);
      this.addTimer(() => {
        this.showSummary = true;
      }, 500);
      this.addTimer(() => {
        this.showClosing = true;
        this.say(CLOSING_TITLE, CLOSING_TEXT).then(() => {
          this.$nextTick(() =>
            scrollToElementDelayed(this.$refs.chatBubble, 72, 80)
          );
        });
      }, CLOSING_DELAY_MS);
    },
    contarInicio() {
      if (this.inicioContado) return;
      this.inicioContado = true;
      medirDemoIniciada("Corregir Test");
    },
    contarFin() {
      if (this.finContado) return;
      this.finContado = true;
      medirDemoTerminada("Corregir Test");
    },
    replay() {
      this.clearTimers();
      this.stage = "choosing";
      this.pickedSlug = null;
      this.revealed = 0;
      this.showSummary = false;
      this.showClosing = false;
      scrollToElementDelayed(this.$refs.demoInner, 58, 0);
      this.play();
    },
    openLoginCta() {
      this.$refs["login-cta"].show();
    },
    login() {
      this.$refs["login-cta"].hide();
      // El chatbot abre el modal de ingreso (no el de registro): ese estado
      // trae el botón de Google MÁS correo y contraseña, así que sirve para
      // quien llega del anuncio sin cuenta y para quien ya la tiene.
      this.$emit("go-to-step", "login");
    },
    backToMenu() {
      this.clearTimers();
      this.$emit("go-to-step", "menu");
    },
  },
};
</script>

<style scoped>
.ctd-demo {
  margin: 10px auto;
  width: 100%;
  font-family: "Ubuntu", Arial, sans-serif;
}

.ctd-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  border-radius: 10px;
  background: rgba(183, 102, 41, 0.12);
  color: #b76629;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  vertical-align: middle;
}

/* Fila aún no analizada durante el barrido: se ve inerte, no vacía. */
.ctd-pending {
  opacity: 0.45;
}

.ctd-just-revealed {
  animation: ctd-pop 380ms ease-out;
}

@keyframes ctd-pop {
  0% {
    background: rgba(183, 102, 41, 0.16);
  }
  100% {
    background: transparent;
  }
}

.ctd-scanning {
  display: inline-block;
  width: 42px;
  height: 8px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    rgba(183, 102, 41, 0.12) 25%,
    rgba(183, 102, 41, 0.28) 50%,
    rgba(183, 102, 41, 0.12) 75%
  );
  background-size: 200% 100%;
  animation: ctd-shimmer 1.1s linear infinite;
}

@keyframes ctd-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.ctd-counters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 16px 0 4px;
}

.ctd-counter {
  flex: 1 1 120px;
  padding: 10px 12px;
  border: 1px solid rgba(26, 35, 50, 0.1);
  border-radius: 12px;
  background: #fff;
  text-align: center;
}

.ctd-counter-num {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.1;
  color: #1a2332;
  font-variant-numeric: tabular-nums;
}

.ctd-counter-label {
  display: block;
  margin-top: 2px;
  font-size: 0.78rem;
  color: #6d7788;
}

.ctd-counter--total {
  background: rgba(183, 102, 41, 0.07);
  border-color: rgba(183, 102, 41, 0.3);
}

.ctd-counter--total .ctd-counter-num {
  color: #b76629;
}

.ctd-summary {
  margin-top: 20px;
  padding: 18px;
  border: 1px solid rgba(26, 35, 50, 0.1);
  border-radius: 16px;
  background: #fff;
}

.ctd-summary-title {
  margin: 0 0 12px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a2332;
}

/* Tabla ancha: scrollea dentro de su caja, nunca empuja la página. */
.ctd-table-wrap {
  overflow-x: auto;
}

.ctd-table {
  width: 100%;
  min-width: 380px;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.ctd-table th {
  padding: 8px 10px;
  border-bottom: 2px solid rgba(26, 35, 50, 0.12);
  color: #6d7788;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  text-align: left;
}

.ctd-table td {
  padding: 9px 10px;
  border-bottom: 1px solid rgba(26, 35, 50, 0.07);
  color: #1a2332;
}

.ctd-num-cell {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.ctd-table-total td {
  background: rgba(183, 102, 41, 0.06);
  font-weight: 700;
}

.ctd-cat {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 0.78rem;
  font-weight: 700;
}

.ctd-cat--ok {
  background: rgba(32, 148, 92, 0.12);
  color: #1c7a4c;
}

.ctd-cat--risk {
  background: rgba(214, 158, 46, 0.16);
  color: #96690d;
}

.ctd-cat--deficit {
  background: rgba(203, 84, 47, 0.14);
  color: #a83c1c;
}

.ctd-cat--severe {
  background: rgba(176, 42, 42, 0.14);
  color: #96201f;
}

.ctd-functions-title {
  margin: 16px 0 6px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #6d7788;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.ctd-functions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ctd-functions li {
  padding: 3px 10px;
  border-radius: 10px;
  background: rgba(26, 35, 50, 0.05);
  color: #3d4757;
  font-size: 0.82rem;
}

.ctd-fade-enter-active {
  transition: opacity 500ms ease, transform 500ms ease;
}

.ctd-fade-enter {
  opacity: 0;
  transform: translateY(14px);
}

@media (prefers-reduced-motion: reduce) {
  .ctd-just-revealed,
  .ctd-scanning {
    animation: none;
  }
  .ctd-fade-enter-active {
    transition: none;
  }
}

/* --- la oferta de arranque -----------------------------------------------
   Una sola fila antes de la demo. Va en el ámbar del producto y nada más: el
   acento fuerte de esta pantalla es el barrido de las 37 palabras, y una
   barra que compita con eso le roba la escena a lo único que convence. */

.ctd-offer {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  gap: 6px 16px;
  margin: 0 0 16px;
  padding: 14px 18px;
  border: 1px solid rgba(183, 102, 41, 0.26);
  border-radius: 14px;
  background: rgba(183, 102, 41, 0.06);
}

.ctd-offer-btn {
  max-width: 100%;
  padding: 10px 24px;
  border: 0;
  border-radius: 999px;
  background: #b76629;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  cursor: pointer;
  transition: background 160ms ease;
}

.ctd-offer-btn:hover,
.ctd-offer-btn:focus-visible {
  background: #a05821;
}

.ctd-offer-note {
  margin: 0;
  max-width: 34ch;
  font-size: 0.82rem;
  line-height: 1.4;
  color: #6d7788;
}

/* En el teléfono la barra es lo primero que se ve y la demo empieza justo
   debajo: el botón ocupa el ancho y la nota se centra bajo él. */
@media (max-width: 575px) {
  .ctd-offer {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    padding: 13px 14px;
  }

  .ctd-offer-note {
    max-width: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ctd-offer-btn {
    transition: none;
  }
}

/* --- el catálogo de arranque ---------------------------------------------
   Los dieciséis test antes de entrar a uno. Vive el primer par de segundos y
   después se va: no es una pantalla del producto, es la respuesta a "¿sirve
   para MI prueba?" puesta antes de que la visitante alcance a preguntársela. */

.ctd-chooser {
  padding: 18px 4px 6px;
}

.ctd-chooser-title {
  margin: 0 0 14px;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6d7788;
}

.ctd-chooser-cols {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px 28px;
}

.ctd-chooser-prof {
  margin: 0 0 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(109, 119, 136, 0.18);
  font-size: 0.9rem;
  font-weight: 700;
  color: #1a2332;
}

.ctd-chooser-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ctd-chooser-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 0.94rem;
  color: #3d4757;
  /* La transición es lo que hace legible que "se eligió solo": sin ella el
     test marcado aparecería ya marcado y parecería el estado inicial. */
  transition: background 240ms ease, border-color 240ms ease, color 240ms ease;
}

.ctd-chooser-item.is-picked {
  background: rgba(183, 102, 41, 0.1);
  border-color: rgba(183, 102, 41, 0.35);
  color: #b76629;
  font-weight: 700;
}

.ctd-chooser-icon {
  font-size: 1.05rem;
  line-height: 1;
}

@media (prefers-reduced-motion: reduce) {
  .ctd-chooser-item {
    transition: none;
  }
}
</style>
